import { createBaseResourceActions } from '../create-base-resource-actions';
import { OrderCardServiceLinkageResourceTypeMappings } from '@aa/nest/resource';

const domainSlug = '[ORDER CARD SERVICE LINKAGE]';
export const orderCardServiceLinkageActions =
  createBaseResourceActions<OrderCardServiceLinkageResourceTypeMappings>(
    domainSlug,
  );
